module.exports = "/assets/d7650d4d39c28e7cd8f7a66b2036903c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JW.png
// module id = 1525
// module chunks = 0